module.exports = __webpack_public_path__ + "img/rent-tab-active.c95fcb61.svg";